
import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import LoginFastBalancesPage, { getDefaultPageData } from "components/pages/LoginFastBalancesPage";
import Classes from "model";

export default function CaptureFastBalancesList(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .submit();

    return <LoginFastBalancesPage data={ data } />
}